import React from 'react';
import Categorycontentmang from '../sections/sec-category-content-mangmenet';
import About from '../sections/sec-about';


const Contentmangementwhychooseus = () => {
    return (  
            <>
                <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
                <About />
                </section>
            </>

    );
}
 
export default Contentmangementwhychooseus;